import { render, staticRenderFns } from "./virtualPropertyDetail.vue?vue&type=template&id=260dcd6b&scoped=true"
import script from "./virtualPropertyDetail.vue?vue&type=script&lang=js"
export * from "./virtualPropertyDetail.vue?vue&type=script&lang=js"
import style0 from "./virtualPropertyDetail.vue?vue&type=style&index=0&id=260dcd6b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "260dcd6b",
  null
  
)

export default component.exports